import deployments from "../../../deployments/deployments.json";

export default deployments;
